// src/routes/sales-team/index.js
import bagspa_views from './bagspa_views'
import 'assets/vendor/nucleo/css/nucleo.css'

const sales_team_routes = {
  collapse  : true,
  path      : '/sales',
  name      : 'Sales Team',
  icon      : 'ni ni-shop',
  state_key : 'sales_team_collapse',
  views     : [...bagspa_views ]
}

export default sales_team_routes
